import { Component, Input, EventEmitter, Output, ChangeDetectionStrategy, OnDestroy, OnChanges, SimpleChanges } from '@angular/core';
import { FormBuilder, ControlContainer, NgForm } from '@angular/forms';
import { QuestionBase } from './../question-base';
import { SelectItem } from 'primeng/components/common/selectitem';
import { ApplicationModel } from '../../models/application.model';
import { constants } from '../../utitlity/constant';
import { Helper } from '../../utitlity/helper';
import { Observable } from 'rxjs';

@Component({
    selector: 'ntb-app-form-field',
    template: require('./dynamic-form-fields.component.html'),
    styles: [require('./dynamic-form-fields.component.css')],
    viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],


})
export class DynamicFormFieldsComponent implements
    OnDestroy, OnChanges {


    @Input() question: QuestionBase<any>;
    @Input() form: NgForm;
    @Input() questions: any = [];
    @Input() aelList: any;
    @Output() changeEvent = new EventEmitter<any>();
    @Output() labelChange: EventEmitter<any> = new EventEmitter<any>();
    changeTimeout: any;
    prefillTimeout: any;
    htmlParse: string;
    @Input() applicationData: ApplicationModel = new ApplicationModel();
    public formSubmitAttempt: boolean;
    public hideDrpdwn: boolean = true;
    cities: any[];
    countriesList: SelectItem[];

    country: any;
    filteredAelSingle: any[];
    enabled: boolean;


    constructor(private formBuilder: FormBuilder) {
    }
    ngOnInit() {
        if (!this.applicationData) {
            this.applicationData = new ApplicationModel();
        }
        this.setFieldData();
        if (Helper.ripHiddenFields.indexOf(this.question.backendField) > -1) {
            this.question.show = false;
        }
        this.onSelectionChange(this.question, true);
        // this.onFieldChange();
        if (this.question.labelText && this.question.dataType === 'checkbox') {
            this.htmlParse = this.question.labelText.replace(/<br>/g, '\n');
        }
    }


    onFieldChange(question, isFirstTime?) {
        // Observable.ti(1000)
        // .subscribe(()=>{
        setTimeout(() => {
            this.onSelectionChange(question, isFirstTime);
        }, 100)

        // })

    }

    onNumberFieldChange(event) {

        this.changeEvent.emit(event);

    }

    onSelectionChange(question, isFirstTime?) {

        this.changeEvent.emit({
            question: question,
            questions: this.questions,
            form: this.form,
            type: 'textChange',
            isFirstTime: isFirstTime
        });

    }

    setFieldData() {
        let value;
        let customerInfo = this.applicationData.customerInfo || {};
        if (this.question.backendField == 'country' && this.question.id=='Field13') {           
            this.question['alignment'] +=' is-disabled';            
        }
     
        else if (this.question.backendField == 'company') {
            value = this.getAELCompany(customerInfo, this.aelList);

        } else if (this.question.dataType == 'dropdown') {
            let prefillValue = customerInfo[this.question.backendField] || this.question.value;
            if (prefillValue) {
                if (this.question.backendField == 'years') {
                }
                value = this.getFieldDropDownValue(prefillValue);
            }

        } else {

            value = customerInfo[this.question.backendField];
        }
        if (typeof value == 'string' && value.trim()) {
            this.question.value = value;
        } else if (typeof value != 'string' && value) {
            this.question.value = value;
        }

    }

    getFieldDropDownValue(data) {
        let value;
        for (let item of this.question.dataValues) {
            if (item.code == data) {
                value = item;
                break;
            }
        }
        return value;
    }



    getAELCompany(prefillData, aelList) {
        let name = prefillData['company'];
        let prefillAelCode = prefillData['aelCode'] ? prefillData['aelCode'].trim() : '9998';
        if (prefillAelCode == '9998') {
            return { name };
        }
        let employerVal = aelList[aelList.findIndex(x => {
            let codeIndex;
            if (x && x.code) {
                codeIndex = x.code.indexOf(prefillAelCode);

                if (codeIndex == 0) {
                    return x.code.length == prefillAelCode.length;
                }
                else {
                    return codeIndex != -1;
                }
            }

        })];
        return employerVal;
    }



    ngOnChanges(changes: SimpleChanges): void {
        if (changes.applicationData && changes.applicationData.currentValue) {
            this.setFieldData();
        }
    }


    ngOnDestroy(): void {
        clearTimeout(this.changeTimeout)
        clearTimeout(this.prefillTimeout)
    }
}




// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/lodash/lodash.js!./~/tslint-loader!./src/app/components/dynamic-form-fields/dynamic-form-fields.component.ts